import {Card} from 'primereact/card'
import ThreeSteps from '../../assets/images/threesteps.jpg'
import Logo from '../../assets/images/favicon.svg'

const Main = () => {
    return (
        <div className="about-page w-full mt-5">
            <div className="content w-full mt-5">
                <div className="grid mt-5">
                    <div className="col-12 md:col-6">
                        <Card>
                            <a href="https://threesteps.az" target="_blank" className="flex justify-content-center align-items-center">
                                <img width="200" height="100" src={ThreeSteps} alt="ThreeSteps"/>
                            </a>
                        </Card>
                    </div>
                    <div className="col-12 md:col-6">
                        <Card>
                            <a href="https://32inci.az/" target="_blank" className="flex justify-content-center align-items-center">
                                <img width="200" height="100" src={Logo} alt="32Inci"/>
                            </a>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main
